import { render, staticRenderFns } from "./UsabilityTable.vue?vue&type=template&id=af11a9ac&"
import script from "./UsabilityTable.vue?vue&type=script&lang=js&"
export * from "./UsabilityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports